export const ACCESS_TOKEN = 'BBCloud-Access-Token-V2'
